<deprecated-text-field
  type="text"
  [name]="name"
  [label]="label"
  [help]="help"
  [required]="!!required"
  [disabled]="!!disabled"
  [readonly]="!!readonly"
  [warning]="warning"
  [placeholder]="formattedPlaceholder"
  [size]="size"
  [textAlign]="textAlign"
  [rightAlignedPrefix]="rightAlignedPrefix"
  [fontSize]="fontSize"
  [actionText]="actionText"
  [(ngModel)]="text"
  (blur)="blur()"
  (keydown)="keydown($event)"
  (action)="action.emit()"
  [analyticsEvents]="analyticsEvents"
></deprecated-text-field>
